import { jwtDecode } from 'jwt-decode';

function checkToken() {
    let token = localStorage.getItem('jwToken')
    if (token) {
        let tokenExpiration = jwtDecode(token).exp;
        // console.log(tokenExpiration)
        let dateNow = new Date();

        if (tokenExpiration < dateNow.getTime() / 1000) {
            return false
        } else {
            // console.log('Token' + localStorage.getItem('jwToken'))
            return true
        }
    }
}

export default checkToken;